export function humanize(str) {
    if (str == undefined) {
        return '';
    }
    var i, frags = str.split('_');
    for (i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1).toLowerCase();
    }
    return frags.join(' ');
}
export function isBlank(str) {
    return !str || str.length == 0;
}
export function isBlankHtml(str) {
    if (!str) {
        return true;
    }
    const doc = new DOMParser().parseFromString(str, 'text/html');
    return !doc.body.textContent || doc.body.textContent.length == 0;
}
export const ellipsis = (input, maxLength = 5) => (input.length > maxLength ? `${input.substring(0, maxLength)}...` : input);
